module.exports = __webpack_public_path__ + "static/media/thermal.f053dab1.jpg";